export default "__VITE_ASSET__B189358k__"